import gql from 'graphql-tag';

export const REMOVE_BROADCAST_ATTACHMENTS = gql`
  mutation RemoveBroadcastAttachments($input: BroadcastRemoveAttachmentsInput!) {
    broadcast {
      removeAttachments(input: $input) {
        error
        success
      }
    }
  }
`;
